function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53402 0.929688C1.05554 0.929688 0.664062 1.32117 0.664062 1.79964C0.664062 2.27812 1.05554 2.66959 1.53402 2.66959C2.01249 2.66959 2.40397 2.27812 2.40397 1.79964C2.40397 1.32117 2.01249 0.929688 1.53402 0.929688ZM6.75374 0.929688C6.27526 0.929688 5.88378 1.32117 5.88378 1.79964C5.88378 2.27812 6.27526 2.66959 6.75374 2.66959C7.23221 2.66959 7.62369 2.27812 7.62369 1.79964C7.62369 1.32117 7.23221 0.929688 6.75374 0.929688ZM4.14388 0.929688C3.6654 0.929688 3.27392 1.32117 3.27392 1.79964C3.27392 2.27812 3.6654 2.66959 4.14388 2.66959C4.62235 2.66959 5.01383 2.27812 5.01383 1.79964C5.01383 1.32117 4.62235 0.929688 4.14388 0.929688Z",
  fill: "#EBEBEB"
});

function Svg3Dots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 3,
    viewBox: "0 0 8 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.8f5f7f1b.svg";
export { ForwardRef as ReactComponent };